var numeral = require('./numeral');

export function abbr(value){
  return numeral(value).format("(0a)")
}
export function n(number){
  return numeral(number).format("0,0[.]00")
}

export default {
  abbr,
  n
}



// WEBPACK FOOTER //
// ./src/shared/numbers/index.js